import { useSystem } from "../store/system-store/store";

export enum ErrorTypes {
  CLIENT = "Client Error",
  NETWORK = "Network Error",
}

export enum NetworkStatusCodes {
  // 4xx Client errors
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  IM_A_TEAPOT = 418,
  MISDIRECTED_REQUEST = 421,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  TOO_EARLY = 425,
  UPGRADE_REQUIRED = 426,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
  UNAVAILABLE_FOR_LEGAL_REASONS = 451,

  // 5xx Server errors
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
  VARIANT_ALSO_NEGOTIATES = 506,
  INSUFFICIENT_STORAGE = 507,
  LOOP_DETECTED = 508,
  NOT_EXTENDED = 510,
  NETWORK_AUTHENTICATION_REQUIRED = 511,
}

export enum ClientStatusCodes {
  // Default Status Codes
  UNDOCUMENTED_ERROR = "LEWK-UXXX",
}

export class ClientError extends Error {
  clientStatusCode: ClientStatusCodes;
  constructor(message: string, clientStatusCode: ClientStatusCodes) {
    super(message);
    this.clientStatusCode = clientStatusCode;
  }
  handle(): void {
    useSystem.getState().setError({
      type: ErrorTypes.CLIENT,
      message: this.message,
      clientStatusCode: this.clientStatusCode,
    });
  }
}

export class NetworkError extends Error {
  networkStatusCode: NetworkStatusCodes;
  constructor(message: string, networkStatusCode: NetworkStatusCodes) {
    super(message);
    this.networkStatusCode = networkStatusCode;
  }
  handle(): void {
    useSystem.getState().setError({
      type: ErrorTypes.NETWORK,
      message: this.message,
      networkStatusCode: this.networkStatusCode,
    });
  }
}
